<template>
  <div class="right-side">
    <div class="content">
      <PropsEditor></PropsEditor>
    </div>
  </div>
</template>
<script setup>
import PropsEditor from '@/components/PropsEditor/PropsEditor.vue';
</script>
<style lang="less" scoped>
.right-side {
  width: @right-side-width;
  padding: 2px 0 0;
  overflow: hidden auto;
}
.content {
  height: 100%;
  padding: 0 18px 20px;
}
</style>
